import URL from '../url'
import Request from '../request'

export const courseTimeSeriesListService = query =>
  new Request(URL.API, URL.COURSE_TIME_SERIES_LIST).post(query)
